import axios from 'axios';

const updateEdit = (url, data, headers) => axios.post(url, data, { headers });

export default updateEdit;
